import { Paper, Stack, Text } from '@mantine/core';

import { COLORS } from '@/utils/colors';

type KpiCardProps = {
  title: string;
  value: string;
  hint: string;
  isHero?: boolean;
};

export const KpiCard = ({ title, value, hint, isHero = false }: KpiCardProps) => {
  return (
    <Paper
      p="md"
      radius="md"
      withBorder
      bg={COLORS.cardBackground}
      style={{
        borderColor: isHero ? 'var(--mantine-color-teal-6)' : undefined,
      }}
    >
      <Stack gap={6}>
        <Text size="sm" c="dimmed">
          {title}
        </Text>
        <Text
          size="xl"
          fw={700}
          style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: '-0.02em' }}
        >
          {value}
        </Text>
        <Text size="xs" c="dimmed">
          {hint}
        </Text>
      </Stack>
    </Paper>
  );
};
